import React from 'react';
import { Flex, Typography } from 'antd';
import { Button, Modal } from '@bettercomp/ui-components';

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Confirms hiding the Survey Refresh Workflow banners. Controlled rather than
 * trigger-based — the close button that opens it lives inside InProgressBanner,
 * a grandchild of the state owner, so `ConfirmModal`'s children-as-trigger API
 * doesn't fit (same rationale as NotifyWhenReadyModal).
 */
export function HideBannersModal({ open, onConfirm, onCancel }: Props) {
  return (
    <Modal
      open={open}
      title="Hide the Survey Refresh Workflow banners?"
      onCancel={onCancel}
      footer={null}
      data-testid="hideSurveySeasonBannersModal"
    >
      <Flex vertical gap={16}>
        <Typography.Text>
          These banners will be hidden on Home and My Data &gt; Surveys pages. You can always turn them
          back on anytime from Settings &gt; Plans.
        </Typography.Text>
        <Flex justify="end" gap={8}>
          <Button
            color="primary"
            variant="outlined"
            onClick={onCancel}
            data-testid="hideSurveySeasonBannersCancel"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={onConfirm}
            data-testid="hideSurveySeasonBannersConfirm"
          >
            Hide Banners
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
